import React, { Component } from 'react';
import '../App.css';
import '../Style/General.css';
import '../Style/Domains.css';
import { Panel } from 'react-bootstrap';
import Domains from '../Engines/Domains.js';
import Description from './Description.js';


const engines = new Map();
var takenDomains = 0;
var freeDomains = 0;
//Description of this group.
//This is what user will see by pressing the info icon.
const description = (
  <div>
    This function lists domains which correspond to your search query, and
    information on whether those domains are linked to websites which are active
    (or inactive) in displaying content.  More information about the domain
    itself can be found by clicking the domain info button which will explain
    whether the domain is registered or not. Websites that are inactive may
    well still be registered.
  </div>
)

class DomainsGroup extends Component {
  constructor () {
    super();
    engines.set("Domains", {});
    this.state = {
      resultCount: 0,
      open: true,
      noSearches: true,
    };
  }

  clear(){
    engines.set("Domains", {});
    this.setState({
      resultCount: 0,
      open: true,
    });
  }

  addResult(source, content, searchQuery) {
    if (engines.has(source)) {
      engines.set(source, content);
      this.setState({
        resultCount: this.state.resultCount + 1,
        noSearches: false
      });
    }
  }

  setHeaderResults() {
    takenDomains = 0;
    freeDomains = 0;
    var results = engines.get("Domains");
    for(var i=0;i<results.length;i++){
      if(results[i].available[0] === 'Taken'){
        takenDomains++;
      }
      else{
        freeDomains++;
      }
    }
  }

  handleClick() {
    this.setState({open: !this.state.open});
  }

  header(){
    var total = takenDomains+freeDomains;
    var count = takenDomains +'/'+ total;
    return(
      <div id="domainpanel" className="resultBox__header" onClick={ ()=> this.setState({ open: !this.state.open })}>
        <div className="resultBox__title">
          Active Websites
          <h2 className="resultBox__title results">{this.state.resultCount !== 0 ? count+' Domains point to active websites' : ''}</h2>
        </div>
      </div>
    );
  }



  render() {
    this.setHeaderResults();
      return (
        <Panel className="resultBox" collapsible expanded={this.state.open} header={this.header()}>
          <div className="resultBox__content clearfix">
            <div className="Description domain-description">
              {description}
            </div>
            <div className="DomainsDiv">
              <Domains content={engines.get("Domains")}/>
            </div>
          </div>
          <div className="resultBox__footer">

          <div className="hide__help">
            <div className="resultBox__help">
              <Description description={description}/>
              <p>What is this report about?</p>
            </div>
          </div>

          </div>
        </Panel>
      );
  }
}

export default DomainsGroup;



// WEBPACK FOOTER //
// ./client/src/Groups/DomainsGroup.js